import React from "react";
import { Gift, Tag, Store } from "lucide-react";

const offers = [
  {
    icon: Gift,
    kicker: "Special",
    title: "Buy 1 Get 1 Free",
    subtitle: "On Grocery essentials",
    accent: "cream",
    testid: "offer-b1g1",
  },
  {
    icon: Tag,
    kicker: "Big Savings",
    title: "Up to 50% Off",
    subtitle: "On selected products across the store",
    accent: "gold",
    testid: "offer-discount",
  },
  {
    icon: Store,
    kicker: "All in One",
    title: "One-Stop Destination",
    subtitle: "Grocery, Clothes, Stationary, Bags, Utensils, Gift Articles & more",
    accent: "leaf",
    testid: "offer-destination",
  },
];

export default function Offers() {
  return (
    <section
      id="offers"
      data-testid="offers-section"
      className="py-20 sm:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="font-latin text-xs uppercase tracking-[0.3em] text-[#9B8B3E] mb-3">
            Special Offers
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#1A1813] leading-tight">
            Today's <span className="text-[#9B8B3E] italic">Best Deals</span>
          </h2>
          <p className="mt-4 text-[#5C5646] text-base sm:text-lg font-latin">
            Exclusive savings on everyday essentials — only at R Maart, Partur.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {offers.map((o, i) => (
            <OfferCard key={i} {...o} />
          ))}
        </div>
      </div>
    </section>
  );
}

function OfferCard({ icon: Icon, kicker, title, subtitle, accent, testid }) {
  const styles = {
    cream: {
      bg: "bg-[#FBF9F6]",
      border: "border-[#E5E1D5]",
      iconBg: "bg-white border border-[#E5E1D5]",
      iconColor: "text-[#9B8B3E]",
      titleColor: "text-[#9B8B3E]",
    },
    gold: {
      bg: "bg-[#9B8B3E]",
      border: "border-[#9B8B3E]",
      iconBg: "bg-white/15 border border-white/20",
      iconColor: "text-white",
      titleColor: "text-white",
      text: "text-white",
    },
    leaf: {
      bg: "bg-[#F5EFE0]",
      border: "border-[#9B8B3E]/20",
      iconBg: "bg-white border border-[#E5E1D5]",
      iconColor: "text-[#4A6B3A]",
      titleColor: "text-[#1A1813]",
    },
  }[accent];

  const isDark = accent === "gold";

  return (
    <div
      data-testid={testid}
      className={`relative overflow-hidden rounded-3xl border ${styles.border} ${styles.bg} p-8 sm:p-10 group hover:-translate-y-1 transition-all duration-500`}
    >
      <div className="absolute top-0 right-0 w-40 h-40 rounded-full bg-black/[0.02] blur-2xl -translate-y-10 translate-x-10 group-hover:translate-x-6 transition-transform" />

      <div
        className={`w-14 h-14 rounded-2xl ${styles.iconBg} ${styles.iconColor} flex items-center justify-center mb-6`}
      >
        <Icon className="w-6 h-6" strokeWidth={1.5} />
      </div>

      <div
        className={`font-latin text-[11px] uppercase tracking-[0.25em] mb-3 ${
          isDark ? "text-white/70" : "text-[#5C5646]"
        }`}
      >
        {kicker}
      </div>

      <h3
        className={`font-display text-2xl sm:text-3xl leading-tight mb-3 font-semibold ${styles.titleColor}`}
      >
        {title}
      </h3>

      <p
        className={`font-latin text-sm sm:text-base leading-relaxed ${
          isDark ? "text-white/85" : "text-[#5C5646]"
        }`}
      >
        {subtitle}
      </p>
    </div>
  );
}
